/**
 * @generated SignedSource<<525eaef62a04802c518fc5a5833e577f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedVideoComponent_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponentCarousel_user">;
  readonly " $fragmentType": "HpSharedVideoComponent_user";
};
export type HpSharedVideoComponent_user$key = {
  readonly " $data"?: HpSharedVideoComponent_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedVideoComponent_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedVideoComponent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedVideoComponentCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "263e2d62c237574cec2e775a67fe4c85";

export default node;
